import type { IntlShape } from 'react-intl';

import type {
  AgentPromptPage,
  AgentPromptPreset,
  FormattedStarterPrompt,
  FormattedStarterPrompts,
} from '../config';
import { AGENT_PROMPT_LIBRARY } from '../content';

const formatPreset = (
  formatMessage: IntlShape['formatMessage'],
  preset: AgentPromptPreset,
): FormattedStarterPrompt => ({
  title: formatMessage(preset.title),
  prompt: formatMessage(preset.prompt),
});

export const buildPageStarterPrompts = (
  formatMessage: IntlShape['formatMessage'],
  page: AgentPromptPage,
): FormattedStarterPrompts => {
  const { write, understand } = AGENT_PROMPT_LIBRARY[page];
  return {
    writePresets: write.map((preset) => formatPreset(formatMessage, preset)),
    understandPresets: understand.map((preset) =>
      formatPreset(formatMessage, preset),
    ),
  };
};
